var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useEffect, useState } from 'react';
import fetchWithTimeout from '../utils/fetchWithTimeout';
import analytics from '../analytics/analytics';
const useGetSurveyContent = submitChatMessagesPayload => {
  const [encodedId, setEncodedId] = useState('');
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDetailsRetrieved, setIsDetailsRetrieved] = useState(false);
  const {
    hotelPayload,
    carPayload,
    flightPayload,
    packagePayload
  } = submitChatMessagesPayload;
  const mergedPayload = Object.assign(Object.assign(Object.assign(Object.assign({}, hotelPayload), carPayload), flightPayload), packagePayload);
  useEffect(() => {
    const fetchLink = offerNumber => __awaiter(void 0, void 0, void 0, function* () {
      var _a, _b, _c;
      const url = `/genai-svc/genai/survey/details/${offerNumber}`;
      const response = yield fetchWithTimeout(url, {
        method: 'GET'
      });
      if (response.ok) {
        const result = yield response.json();
        setDetails((_a = result === null || result === void 0 ? void 0 : result.details) !== null && _a !== void 0 ? _a : []);
        setEncodedId((_b = result === null || result === void 0 ? void 0 : result.encodedId) !== null && _b !== void 0 ? _b : '');
        setIsDetailsRetrieved((_c = result === null || result === void 0 ? void 0 : result.isDetailsRetrieved) !== null && _c !== void 0 ? _c : false);
      }
      setLoading(false);
    });
    const offerNumber = mergedPayload === null || mergedPayload === void 0 ? void 0 : mergedPayload.offerNumber;
    if (offerNumber) {
      fetchLink(offerNumber).catch(e => analytics.log({
        message: e.message,
        source: 'useGetSurveyLink'
      }));
    }
  }, []);
  return {
    details,
    encodedId,
    isDetailsRetrieved,
    loading
  };
};
export default useGetSurveyContent;